import { useContext, useMemo } from "react";

import CssBaseline from "@mui/material/CssBaseline";
import { createTheme, ThemeProvider } from "@mui/material";

import DashboardContext from "../context/DashboardContext";

export default function ThemeConfig({ children }) {
  const {
    customPrimaryColor,
  } = useContext(DashboardContext);

  const themeOptions = useMemo(
    () => ({
      palette: {
        primary: { main: customPrimaryColor },
        whiteColor: { main: "#ffffff" },
        carbonGray: { main: "#282828" },
        background: { default: "#f5f5f5" },
        golden: { main: "#ccac00" },
        silver: { main: "#C0C0C0" },
        bronze: { main: "#c07046" },
        cb: { main: "#539957" },
        buttonColor:{main:"#379C44"}
      },
    }), [customPrimaryColor]
  );

  const theme = createTheme(themeOptions);

  return (
    <ThemeProvider theme={ theme }>
      <CssBaseline />
      { children }
    </ThemeProvider>
  );
};
